import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostToolRequirement from '.';

interface IPostToolRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostToolRequirement = ({onSuccess}: IPostToolRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IToolAdvertisementPayload) => {
      return PostToolRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostToolRequirement};
